import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/programs')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/program' })
  },
})
